/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGlobalRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGlobalRemoteSessionClientRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGlobalRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionClientSecurity$outboundSchema: z.ZodMiniType<
  GetGlobalRemoteSessionClientSecurity$Outbound,
  GetGlobalRemoteSessionClientSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getGlobalRemoteSessionClientSecurityToJSON(
  getGlobalRemoteSessionClientSecurity: GetGlobalRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionClientSecurity$outboundSchema.parse(
      getGlobalRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type GetGlobalRemoteSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGlobalRemoteSessionClientRequest$outboundSchema: z.ZodMiniType<
  GetGlobalRemoteSessionClientRequest$Outbound,
  GetGlobalRemoteSessionClientRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getGlobalRemoteSessionClientRequestToJSON(
  getGlobalRemoteSessionClientRequest: GetGlobalRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    GetGlobalRemoteSessionClientRequest$outboundSchema.parse(
      getGlobalRemoteSessionClientRequest,
    ),
  );
}
